<template>
	<div @click="handleClick">
		<div class="relative flex w-full items-center gap-x-3">
			<div v-if="option.icon" class="flex h-full items-center justify-center">
				<Component
					:is="option.icon?.component"
					v-bind="option.icon?.bindings"
				/>
			</div>
			<div class="flex w-full items-center gap-3">
				<template v-if="typeof option.label === 'string'">
					<span class="font-sans text-sm font-normal leading-normal text-white">
						{{ option.label }}
					</span>
				</template>
				<Component :is="option.label" v-else />
				<Badge
					v-if="option.badge"
					variant="secondary"
					class="h-auto w-10 shrink-0 justify-center rounded-[2px] border-primary-light-4 bg-primary-light-4 px-1.5 py-0.5 font-sans font-medium text-[10px] leading-[150%]"
				>
					{{ option.badge }}
				</Badge>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { handleEventProps } from '~/composables/events/headerEvents';
import { useEvents } from '~/composables/events/useEvents';

import { Badge } from '~/components/ui/badge';

import { type NavDefaultOptionConfig } from '.';

const { trackHeader } = useEvents();

const props = defineProps<{
	option: NavDefaultOptionConfig;
}>();

const handleClick = () => {
	handleEventProps(
		props.option.eventProps,
		trackHeader.handleEventMenuHeaderClick
	);
	props.option.eventCallback?.();
};
</script>
